<template>
  <div id="content">
    <div id="newsdetail">
      <div class="news_1">
        <div  v-if="$i18n.locale == 'en'" class="news_101">{{news.name_en}}</div>
        <div  v-else class="news_101">{{news.name}}</div>
        <div v-if="$i18n.locale == 'en'" class="news_102"> DATE ISSUED:{{news.year}}-{{news.month}}-{{news.day}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;CLICK:{{news.tickcount}}
         </div>
         <div v-else class="news_102"> 发表日期：{{news.year}}-{{news.month}}-{{news.day}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点击击数:{{news.tickcount}}
        </div>
        <p style="margin-right: 0px" dir='\"ltr\"' align='\"center\"'></p>
        
      <br>
      <hr />
      <br>
    <div v-if="$i18n.locale == 'en'"   v-html="news.content_en">
    </div>
    <div  v-else  v-html="news.content">
    </div>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: 'NewsDetail',
   data() {
    return {
      news:{},
    };
  },
  mounted() {
    // 使用
    const params = {id: this.$route.params.id}; // 参数
    fetch.post("/api/ApiNews/Get", params).then(
      (res) => {
        this.news = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  }
}

</script>

<style>
#newsdetail {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
/*4-2新闻动态详情*/
.news_1{ width:70%; margin:26px auto auto;}
.news_101{ width:100%; font-size:18px; color:#333; line-height:30px; text-align:center;}
.news_102{ text-align:center; font-size:12px; color:#666; margin-top:15px;}
.bdsharebuttonbox{ display:inline-block; vertical-align:middle; margin-left:24px;}

.news_103{ width:72%; height:auto !important; min-height:500px; _height:500px; font-size:14px; color:#333; margin-top:24px;}
.news_103 img{ max-width:1100px;}

</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue